const i = {
  name: "AccessibilityPersonFilled",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.5003 2.5C14.5003 3.88 13.3803 5 12.0003 5C10.6203 5 9.50027 3.88 9.50027 2.5C9.50027 1.12 10.6203 0 12.0003 0C13.3803 0 14.5003 1.12 14.5003 2.5Z" fill="currentColor"/>
<path d="M21.5738 7.886C19.2832 8.83386 16.9035 9.42966 14.5009 9.67341C14.5189 12.0972 14.9136 14.5156 15.6827 16.814L17.423 22.0248L14.5775 22.9752L12.8378 17.766C12.4912 16.7303 12.212 15.6743 12.0003 14.606C11.7885 15.6743 11.5093 16.7303 11.1627 17.766L9.42302 22.9752L6.57751 22.0248L8.31751 16.8148C9.08668 14.5165 9.48164 12.0972 9.49962 9.6734C7.09706 9.42966 4.7174 8.83386 2.42676 7.886L3.57381 5.11395C9.00656 7.36199 14.994 7.36199 20.4268 5.11395L21.5738 7.886Z" fill="currentColor"/>
</svg>
  `
};
export {
  i as AccessibilityPersonFilled
};
